var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlumnitibg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1437,
    height: 2370,
    viewBox: "0 0 1437 2370",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1437,
    height: 2370,
    fill: "url(#paint0_linear_6_2)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6_2",
    x1: 718.5,
    y1: 0,
    x2: 718.5,
    y2: 2370,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B112C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#252B58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B112C"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlumnitibg);
export default __webpack_public_path__ + "static/media/alumnitibg.0078f8550390857b4a4fe0498d3020a8.svg";
export { ForwardRef as ReactComponent };